const Map = () => import('@/views/person/Map.vue')
const Index = () => import('@/views/person/Index.vue')
export default [{
  path: '/personservice',
  meta: {
    title: '工人劳务'
  },
  components: {
    right: Index,
    default: Map
  },
  redirect: '/personservice/duty',
  children: [{
    path: '/personservice/duty',
    meta: {
      title: '在岗人员',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/person/onDuty.vue')
  }, {
    path: '/personservice/index',
    meta: {
      title: '劳务考勤',
      hasBack: false,
      activeMenu: '/home/board'
    },
    component: () => import('@/views/person/PersonService.vue')
  }]
}]
